import React from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';

type HeroSectionProps = {
  title: string;
  description?: string;
  sx?: SxProps<Theme>;
};

export default function HeroSection({ title, description, sx }: HeroSectionProps) {
  return (
    <Box
      sx={{
        textAlign: 'center',
        mb: 8,
        py: 6,
        color: 'white',
        backgroundImage: "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url('/assets/images/breadcrumb.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        ...sx,
      }}
    >
      <Typography variant="h4" fontWeight={700} gutterBottom sx={{ color: '#d32f2f' }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="h5" sx={{ opacity: 0.95, maxWidth: 600, mx: 'auto' }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
